export const profilePerpetualTableHandlers = () => {
    $('#js-perpetual-collapse').click(function () {
        const target = $(this).data('target');
        updateIcon($(target).hasClass('show'));
        $(target).collapse('toggle');
    });
};

const updateIcon = isCollapsed => {
    $('.perpetual-collapse--button-container .hidden').removeClass('hidden');
    $(`.perpetual-collapse--button-container .fa-chevron-${isCollapsed ? 'up' : 'down'}`).addClass('hidden');
};
